const state = () => ({
    reservation_allow_days: 30,                        // 相談予約可能日数
    reservation_cancel_allowable_minute: 1440,         // 相談予約確定時間(分)／診療予約キャンセル受付時間(分)
    reservation_cancel_after_confirm_doctor: 0,        // 予約確定後もキャンセルボタンを表示（医師）
    reservation_cancel_after_confirm_user: 0,          // 予約確定後もキャンセルボタンを表示（ユーザ）
    reservation_multiple: 0,                           // 複数人予約
    consultation_cancel_policy: '',                    // キャンセルポリシー
    consultation_cancel_policy_doctor_pass: '',        // キャンセルポリシー（ドクターパス）
    consultation_cancel_policy_flat_rate: '',          // キャンセルポリシー（定額プラン）
    consultation_cancel_policy_doctor: '',  
    consultation_enter_min_start: 10,                  // 入室可能時間／相談再開受付時間（予定開始時間の◯分前から）
    consultation_enter_min_end: 10,                    // 入室可能時間／相談再開受付時間（予定終了時間の◯分後まで）
    consultation_absence_min_doctor: 5,                // 未入室終了時間（医師: 予定開始時間の◯分後）
    consultation_allow_absence_doctor: 0,              // 医師未入室終了を有効にする
    consultation_allow_absence_user: 0,                // 患者未入室終了を有効にする
    consultation_cancel_doctor_login: 0,               // 医師の事前ログインがない場合は予約をキャンセルする
    consultation_matching_cancel_min: 720,             // マッチング予約の自動キャンセル（相談開始の◯分前）
    consultation_matching_auto_min: 4320,              // 相談予約の自動マッチング（相談開始の◯分前から）
    consultation_end_time_count: 300,                  // 相談終了カウントダウン
    consultation_fuzzy_time: 60,                       // ファジー終了時間
    mail_signature: '',                                // 配信メール署名欄
    mail_header_consultation_reserved: '',             // 予約受付メールヘッダ
    mail_header_consultation_finished: '',             // 診療終了メールヘッダ
    mail_header_invoice_cash: '',                      // 受診料請求（現金）メールヘッダ
    mail_header_invoice_bank: '',                      // 受診料請求（銀行振込）メールヘッダ
    mail_header_user_registered: '',                   // 会員登録完了メールヘッダ
    basic_name: '',                                    // 医療機関名
    basic_logo: '',                                    // ロゴ画像URL
    basic_info: '',                                    // 患者へのお知らせ
    medical_record_flg_published: 1,                   // 診療記録の医師共有 ※国内版のみで参照中
    medical_record_can_export: 1,                      // 相談記録のエクスポート
    payment: 0,                                        // 決済機能
    payment_consultation_auto_charge: 0,               // 相談予約の自動支払設定
    payment_consultation_auto_charge_after_min: 720,   // 記録公開から自動支払までの間隔（分）
    payment_doctor_allow: 0,                           // 医師モードの請求データ表示
    payment_on_reservation: 0,                         // 相談予約時に同時決済する
    timezone: 0,                                       // タイムゾーン設定（会員）
    flg_user_code: 0,                                  // 所属コードのフォーマット設定
    user_code: null,                                   // 所属コードのフォーマット
    law: '',                                           // 特定商取引法に基づく表記
    law_terms_updated_at: '',                          // 利用規約の最終更新日時
    law_terms_version: '',                             // 利用規約のバージョン
    law_privacy_updated_at: '',                        // プライバシーポリシーの最終更新日時
    law_privacy_version: '',                           // プライバシーポリシーのバージョン
    law_terms_flat_rate_plan_updated_at: '',           // 定額プラン利用特約の最終更新日時
    law_terms_flat_rate_plan_version: '',              // 定額プラン利用特約のバージョン
    law_terms_travel_doctor_pass_updated_at: '',       // 海外旅行ドクターパス利用特約の最終更新日時
    law_terms_travel_doctor_pass_version: '',          // 海外旅行ドクターパス利用特約のバージョン
    law_terms_study_abroad_doctor_pass_updated_at: '', // 留学ドクターパス利用特約の最終更新日時
    law_terms_study_abroad_doctor_pass_version: '',    // 留学ドクターパス利用特約のバージョン
    invoice_item_name: '',                             // 請求項目名
    subscription: 0,                                   // 契約プラン機能
    admin_agora: 0,                                    // 管理者向け相談室でビデオ通話を有効にする
    maintenance_reservation_from: null,                // 相談予約制限（開始）
    maintenance_reservation_to: null,                  // 相談予約制限（終了）
    campaign_register_token: '',                       // 会員登録時のキャンペーンtoken
    consultation_restart_allowable_minute: 30,         // 【廃止】相談再開受付時間(分)
    reservation_allow_before_min: 1440,                // 【廃止】相談予約可能時間
    consultation_absence_min_user: 30,                 // 【廃止】未入室終了時間（ユーザ: 予定開始時間の◯分後）
    consultation_doctor_interval: 0,                   // 【廃止】医師モードの相談スケジュール時間枠設定
})

const mutations = {
    setConfig(state, {key, value}) {
        state[key] = value
    },

    setConfigs(state, configurations) {
        for (let key of Object.keys(configurations)) {
            state[key] = configurations[key]
        }
    },
};

const getters = {}
const actions = {}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
